import { normalizeKey } from '../../shared/verteoffice/utils/helpers'

/* Mapeo inverso: dado el NOMBRE de una actividad, retorna el TIPO de dominio del hijo.
   Usado en el formulario de inicio de jornada para filtrar dropdowns en cascada. */
export function createActivityTypeMapping() {
  // Nombre de actividad general -> tipo de dominio del objetivo
  const rawGeneralToObjectiveType: Record<string, string> = {
    'ATENCION AL CLIENTE': 'ACTIVITY_OBJECTIVE_ATENTION',
    'COMUNICACION': 'ACTIVITY_OBJECTIVE_COMMUNICATION',
    'DATA & DESARROLLO': 'ACTIVITY_OBJECTIVE_DATA_DEV',
    'ESTRUCTURA DE PROCESOS': 'ACTIVITY_OBJECTIVE_STRCUTURE_PROCESS',
    'GESTION DE PROCESOS': 'ACTIVITY_OBJECTIVE_MNG_PROCESSES',
    'PLANEACION ESTRATEGICA': 'ACTIVITY_OBJECTIVE_PLAN_STRATEGY',
    'REPORTING': 'ACTIVITY_OBJECTIVE_REPORTING',
    'TALENTO HUMANO Y AUSENTISMO': 'ACTIVITY_OBJECTIVE_HUMAN_TALENT_ABSENTEEISM'
  }

  // Nombre de objetivo -> tipo de dominio de la actividad especifica
  const rawObjectiveToSpecificType: Record<string, string> = {
    'ATENCION A SOLICITUDES': 'SPECIFIC_ACTIVITY_ATTENTION_SOLI',
    'MESA DE TRABAJO': 'SPECIFIC_ACTIVITY_ATTENTION_TABLE',
    'DISEÑO': 'SPECIFIC_ACTIVITY_DESIGN',
    'SOPORTE': 'SPECIFIC_ACTIVITY_SUPPORT',
    'DESARROLLO': 'SPECIFIC_ACTIVITY_DEV',
    'CAPACIDAD': 'SPECIFIC_ACTIVITY_CAPACITY',
    'MODELOS BI': 'SPECIFIC_ACTIVITY_MODEL_BI',
    'TABLEROS BI': 'SPECIFIC_ACTIVITY_TABLE_BI',
    'ESTANDARIZACION': 'SPECIFIC_ACTIVITY_STANDARD',
    'INSTRUCTIVOS': 'SPECIFIC_ACTIVITY_INSTRUCTIVE',
    'MALLA DE OPERACION': 'SPECIFIC_ACTIVITY_OPERATION',
    'GESTION ADMINISTRATIVA TH': 'SPECIFIC_ACTIVITY_ADMINTH',
    'GESTION CAPACITACION Y DESARROLLO': 'SPECIFIC_ACTIVITY_CAP_DEV',
    'GESTION CONTABLE Y FINANCIERA': 'SPECIFIC_ACTIVITY_CONT_FIN',
    'GESTION ADMINISTRATIVA': 'SPECIFIC_ACTIVITY_MNG_ADMIN',
    'DESARROLLO DE NEGOCIOS E INNOVACION': 'SPECIFIC_ACTIVITY_DEV_BUSINESS_INNOVATION',
    'GESTION CULTURA Y BIENESTAR': 'SPECIFIC_ACTIVITY_CULTURE_WELLBEING',
    'GESTION DE CAMPAÑAS Y CONVOCATORIAS': 'SPECIFIC_ACTIVITY_CAMPAIGN_CALLING',
    'GESTION DE CONTRATOS': 'SPECIFIC_ACTIVITY_MNG_CONTRACT',
    'GESTION DE DESVINCULACION': 'SPECIFIC_ACTIVITY_MNG_DISENGAGEMENT',
    'GESTION ECOEFICIENCIA': 'SPECIFIC_ACTIVITY_MNG_ECOEFICIENCIA',
    'GESTION DE PAGOS': 'SPECIFIC_ACTIVITY_MNG_PAYMENTS',
    'GESTION DE REPORTING': 'SPECIFIC_ACTIVITY_MNG_REPORTING',
    'GESTION DE SELECCION VINCULACION Y CONTRATACION': 'SPECIFIC_ACTIVITY_MNG_SEL_ENG_CONTRT',
    'GESTION DE SOSTENIBILIDAD': 'SPECIFIC_ACTIVITY_MNG_SUSTAINABILITY',
    'GESTION DESEMPEÑO': 'SPECIFIC_ACTIVITY_PERFORMANCE',
    'GESTION DOCUMENTAL TH': 'SPECIFIC_ACTIVITY_MNG_DOCUMENT_TH',
    'GESTION FUTURO V': 'SPECIFIC_ACTIVITY_MNG_FUTURE_V',
    'GESTION INDUCCION - REINDUCCION': 'SPECIFIC_ACTIVITY_MNG_INDUCTION_REDUCTION',
    'GESTION MERCADOS Y TARIFAS': 'SPECIFIC_ACTIVITY_MNG_MARKET_TARIFFS',
    'GESTION PLANEACION': 'SPECIFIC_ACTIVITY_MNG_PLANNING',
    'GESTION SOLUCIONES TECNICAS': 'SPECIFIC_ACTIVITY_MNG_SOLUTION_TECH',
    'GESTIONES INTERNAS': 'SPECIFIC_ACTIVITY_INTERNAL',
    'SG- SST': 'SPECIFIC_ACTIVITY_SG_SST',
    'SISTEMA DE GESTION INTEGRAL': 'SPECIFIC_ACTIVITY_SYSTEM_MNG_INTEGRAL',
    'VERTEBRA HELP (CLIENTE INTERNO)': 'SPECIFIC_ACTIVITY_VERTEBRA_HELP_INTERNAL',
    'ALINEACION ESTRATEGICA': 'SPECIFIC_ACTIVITY_ALIGN_STRATEGY',
    'COORDINACION AREAS': 'SPECIFIC_ACTIVITY_COORDINATION_AREAS',
    'DIRECCION EQUIPO': 'SPECIFIC_ACTIVITY_DIRECTION_TEAM',
    'ESTRATEGIA EMPRESA': 'SPECIFIC_ACTIVITY_STRATEGY_COMPANY',
    'REPORTES ECOEFICIENCIA': 'SPECIFIC_ACTIVITY_REPORTS_ECOEFICIENCIA',
    'REPORTES INTERNOS': 'SPECIFIC_ACTIVITY_REPORTS_INTERNAL',
    'REPORTES MERCADOS Y TARIFAS': 'SPECIFIC_ACTIVITY_REPORTS_MARKET_TARRIFS',
    'REPORTES PAGOS': 'SPECIFIC_ACTIVITY_REPORTS_PAYMENTS',
    'REPORTES SOLUCIONES TECNICAS': 'SPECIFIC_ACTIVITY_REPORTS_SOLUTIONS_TECH',
    'AUSENCIA LABORAL': 'SPECIFIC_ACTIVITY_ABSENT_WORK',
    'CULTURA VERTEBRA': 'SPECIFIC_ACTIVITY_CULTURAL_VERTEBRA',
    'DESVINCULACION': 'SPECIFIC_ACTIVITY_DISENGAGEMENT',
    'INDUCCION - RE INDUCCION': 'SPECIFIC_ACTIVITY_INDUCTION_REINDUCTION',
    'SELECCION': 'SPECIFIC_ACTIVITY_SELECTION',
    'SISTEMA DE GESTION': 'SPECIFIC_ACTIVITY_SYSTEM_MNG'
  }

  const generalToObjectiveType = Object.fromEntries(
    Object.entries(rawGeneralToObjectiveType).map(([k, v]) => [normalizeKey(k), v])
  )

  const objectiveToSpecificType = Object.fromEntries(
    Object.entries(rawObjectiveToSpecificType).map(([k, v]) => [normalizeKey(k), v])
  )

  return {
    generalToObjectiveType,
    objectiveToSpecificType
  }
}

export const { generalToObjectiveType, objectiveToSpecificType } = createActivityTypeMapping()
